import { render } from "./ListaDeAgendamentosCalendar.vue?vue&type=template&id=60c5d6a8"
import script from "./ListaDeAgendamentosCalendar.vue?vue&type=script&lang=js"
export * from "./ListaDeAgendamentosCalendar.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__